import { memo, useCallback, useEffect, useState } from 'react';
import { Typography } from '@components/styledComponents';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Chip } from '@mui/material';

function SelectedMerchantsTable({ merchants, handleRemoveMerchant }) {
  const [tableMerchants, setTableMerchants] = useState([]);

  const renderLOB = useCallback(({ row: { lob } }) => lob.lobName, []);
  const renderMerchants = useCallback(
    ({ value: rowMerchants }) => (
      <Box
        padding={1}
        spacing={1}>
        {rowMerchants.map((merchant) => (
          <Chip
            sx={{ margin: '3px' }}
            key={merchant.platformName}
            label={merchant.platformName}
            variant="outlined"
          />
        ))}
      </Box>
    ),
    [],
  );
  const renderDelete = useCallback(
    ({ id }) => [
      <GridActionsCellItem
        key={id}
        icon={<DeleteIcon />}
        label="Remove merchants"
        onClick={() => handleRemoveMerchant(id)}
      />,
    ],
    [handleRemoveMerchant],
  );

  useEffect(() => {
    setTableMerchants(merchants);
  }, [merchants]);

  return (
    <div style={{ width: '100%' }}>
      <Typography
        variant="h4"
        sx={{ marginBottom: '16px' }}>
        Selected merchants
      </Typography>
      <DataGrid
        autoHeight
        rows={tableMerchants}
        columns={[
          {
            field: 'lob',
            headerName: 'LOB',
            sortable: false,
            flex: 1,
            valueGetter: renderLOB,
            type: 'string',
          },
          {
            field: 'merchants',
            headerName: 'Merchants',
            headerAlign: 'center',
            sortable: false,
            flex: 10,
            renderCell: renderMerchants,
          },
          {
            field: 'actions',
            headerName: 'Actions',
            sortable: false,
            flex: 1,
            type: 'actions',
            getActions: renderDelete,
          },
        ]}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableDensitySelector
        getRowHeight={() => 'auto'}
        getRowId={({ lob }) => lob.lobId}
        pageSize={10}
        rowsPerPageOptions={[10]}
      />

      <Typography variant="h4">Add more merchants</Typography>
    </div>
  );
}

export default memo(SelectedMerchantsTable);
